module.exports = __webpack_public_path__ + "img/ug.svg";